import * as React from "react";

import { useAuthContext } from "../../../auth-state";

export const PlanError: React.FC<{
  title: string;
}> = ({ title }) => {
  const authAcc = useAuthContext();
  return (
    <article className="message is-danger mt-4">
      <div className="message-body content">
        <h1 className="has-text-weight-bold has-text-danger">権限エラー</h1>
        <p>
          {authAcc.data?.orgName}
          でご契約いただいているプランでは、{title}
          を閲覧することができません。
          <br />
          システム管理者へご連絡ください。
        </p>
        <p>
          <dl>
            <dt>URL:</dt>
            <dd>{window.location.href}</dd>
            <dt>userId:</dt>
            <dd>{authAcc.data?.id}</dd>
            <dt>organizationId:</dt>
            <dd>{authAcc.data?.orgId}</dd>
            <dt>orgSlug:</dt>
            <dd>{authAcc.data?.orgSlug}</dd>
          </dl>
        </p>
      </div>
    </article>
  );
};
